export default {
  BLIP_1: {
    title: 'Mensajes Recibidos',
    description: 'Total de mensajes recibidos en el período (de los contactos al bot).',
  },
  BLIP_2: {
    title: 'Mensajes Enviados',
    description: 'Total de mensajes enviados en el período (del bot a los contactos).',
  },
  BLIP_3: {
    title: 'Mensajes Activos',
    description: 'Total de mensajes activos enviados en el período (24 horas después de la última interacción del contacto).',
  },
  BLIP_4: {
    title: 'Total de Contactos Únicos en el Período',
    description: 'Total de contactos únicos en el período que recibieron o enviaron un mensaje al bot.',
  },
  BLIP_5: {
    title: 'Contactos con Interacción en el Período',
    description: 'Total de contactos únicos en el período que enviaron un mensaje al bot.',
  },
  BLIP_6: {
    title: 'Contactos Únicos por Intervalo',
    description: 'Contactos únicos por intervalo (día o mes) que recibieron o enviaron un mensaje al bot.',
  },
  BLIP_7: {
    title: 'Contactos con Interacción por Intervalo',
    description: 'Contactos únicos por intervalo (día o mes) que enviaron un mensaje al bot.',
  },
  BLIP_8: {
    title: 'Mensajes Enviados por Intervalo',
    description: 'Mensajes enviados por intervalo (día o mes) del bot a los contactos.',
  },
  BLIP_9: {
    title: 'Mensajes Recibidos por Intervalo',
    description: 'Mensajes recibidos por intervalo (día o mes) del bot a los contactos.',
  },
  BLIP_10: {
    title: 'Mensajes Activos por Intervalo',
    description: 'Mensajes activos enviados por intervalo (día o mes), 24 horas después de la última interacción del contacto.',
  },
  BLIP_11: {
    title: 'Volumen de Mensajes en el Período',
    description: 'Gráfico de línea con el total de mensajes enviados y recibidos dentro del período seleccionado.',
  },
  BLIP_12: {
    title: 'Contactos que No Respondieron',
    description: 'Total de contactos únicos que no respondieron a ningún mensaje enviado por el chatbot y no iniciaron ninguna conversación en el período seleccionado.',
  },
  BLIP_13: {
    title: 'Contactos con Interacción vs. Contactos que No Respondieron',
    description: 'Gráfico de línea con el total de contactos únicos que no respondieron y los que interactuaron con el chatbot dentro del período seleccionado.',
  },
  BLIP_14: {
    title: 'Tasa de Rechazo',
    description: 'Porcentaje del total de contactos únicos que no respondieron al chatbot dividido por el número total de contactos únicos en el período seleccionado. Calculado mediante la fórmula: Contactos que no respondieron / Total de contactos únicos * 100%.',
  },
  BLIP_15: {
    title: 'Mensajes Activos por Canal',
    description: 'Tabla con el total de mensajes activos enviados por canal en el período de tiempo seleccionado. Se consideran mensajes activos aquellos enviados por el chatbot más de 24 horas después del último mensaje recibido del contacto.',
  },
  BLIP_16: {
    title: 'Tasa de Interacción',
    description: 'Porcentaje del total de contactos únicos que respondieron e interactuaron con el chatbot sobre el total de contactos únicos en el período seleccionado. Calculado mediante la fórmula: Contactos con Interacción / Total de contactos únicos * 100%.',
  },
  BLIP_17: {
    title: 'Total de Mensajes Traficados',
    description: 'Total de mensajes enviados y recibidos por el chatbot en el flujo conversacional. Incluye también mensajes intercambiados en Blip Desk entre contactos y agentes.',
  },
  BLIP_18: {
    title: 'Total de Eventos Personalizados',
    description: 'Número total de Eventos Personalizados según las opciones aplicadas en el filtro dentro del período seleccionado.',
  },
  BLIP_19: {
    title: 'Distribución de Eventos Personalizados',
    description: 'Distribución de Eventos Personalizados según las opciones aplicadas en el filtro dentro del período seleccionado.',
  },
  BLIP_20: {
    title: 'Distribución de Eventos Personalizados (Porcentaje)',
    description: 'Distribución de Eventos Personalizados según las opciones aplicadas en el filtro dentro del período seleccionado.',
  },
  BLIP_21: {
    title: 'Eventos Personalizados en el Tiempo',
    description: 'Distribución de Eventos Personalizados según las opciones aplicadas en el filtro a lo largo de un período de tiempo. Nota: Solo se muestran las 50 acciones más numerosas.',
  },
  BLIP_22: {
    title: 'Mis Campañas',
    description: 'Total de campañas activas enviadas y programadas a través de contactos inteligentes en el período seleccionado.',
  },
  BLIP_23: {
    title: 'Tickets Abiertos',
    description: 'Total de tickets abiertos en el período seleccionado.',
  },
  BLIP_24: {
    title: 'Tickets Perdidos',
    description: 'Total de atenciones cerradas por el cliente mientras aún estaba en la cola de atención y aún no había sido asignado a un agente.',
  },
  BLIP_25: {
    title: 'Tickets Abandonados',
    description: 'Total de atenciones cerradas por el cliente que luego fueron distribuidas o tomadas por un agente.',
  },
  BLIP_26: {
    title: 'Tickets Atendidos',
    description: 'Total de atenciones finalizadas o transferidas a otra cola o agente.',
  },
  BLIP_27: {
    title: 'Tickets Cerrados',
    description: 'Total de la suma de atenciones perdidas, abandonadas y atendidas.',
  },
  BLIP_28: {
    title: 'Embudo de Conversión',
    description: 'Muestra métricas de rendimiento por etapa de los envíos de mensajes activos realizados por los contactos inteligentes seleccionados.',
  },
  BLIP_29: {
    title: 'Tiempo Máximo en Cola',
    description: 'Muestra el mayor tiempo que un cliente esperó en la cola hasta ser asignado a un agente. Solo se consideran los tickets cerrados en el período seleccionado que ya han sido eliminados de la pantalla del agente.',
  },
  BLIP_30: {
    title: 'Tiempo Máximo hasta la 1ª Respuesta',
    description: 'Muestra el tiempo máximo que un cliente tardó en recibir el primer contacto del agente tras ser asignado. Solo se consideran los tickets cerrados en el período seleccionado que ya han sido eliminados de la pantalla del agente.',
  },
  BLIP_31: {
    title: 'Tiempo Promedio en Cola',
    description: 'Tiempo promedio que los clientes esperan en la cola hasta ser asignados a un agente. Calculado usando solo los tickets cerrados en el período seleccionado que ya han sido eliminados de la pantalla del agente.',
  },
  BLIP_32: {
    title: 'Tiempo Promedio hasta la 1ª Respuesta',
    description: 'Tiempo promedio que los agentes tardan en enviar el primer mensaje al cliente tras la asignación. Calculado usando solo los tickets cerrados en el período seleccionado que recibieron una primera respuesta y han sido eliminados de la pantalla del agente.',
  },
  BLIP_33: {
    title: 'Tiempo Promedio de Espera',
    description: 'Tiempo promedio que un cliente tarda en recibir la primera atención, medido desde que el ticket se asigna a una cola hasta que el agente envía la primera respuesta.',
  },
  BLIP_34: {
    title: 'Tiempo Promedio de Respuesta',
    description: 'Tiempo promedio que los agentes tardan en responder los mensajes del cliente. Calculado usando solo los tickets con al menos un intercambio completo entre cliente y agente, cerrados en el período seleccionado y ya eliminados de la pantalla del agente.',
  },
  BLIP_35: {
    title: 'Tiempo Promedio de Atención',
    description: 'Calculado usando solo los tickets cerrados en el período que ya han sido eliminados de la pantalla del agente.',
  },
  BLIP_36: {
    title: 'Volumen de Tickets por Día',
    description: 'Número de tickets abiertos y cerrados por día dentro del período de tiempo seleccionado.',
  },
  BLIP_37: {
    title: 'Disponibilidad de Agentes',
    description: 'Informe que muestra el tiempo que cada agente pasó en cada estado, proporcionando una visión de su disponibilidad en el período de tiempo seleccionado.',
  },
  BLIP_38: {
    title: 'Informes de Atención - Agentes',
    description: 'Informe de tickets finalizados y sus métricas respectivas por Agente dentro del período de tiempo seleccionado.',
  },
  BLIP_39: {
    title: 'Informes de Atención - Colas',
    description: 'Informe de tickets finalizados y sus métricas respectivas por Cola dentro del período de tiempo seleccionado.',
  },
  BLIP_40: {
    title: 'Informes de Atención - Etiquetas',
    description: 'Informe de tickets finalizados y sus métricas respectivas por Etiqueta dentro del período de tiempo seleccionado.',
  },
  BLIP_41: {
    title: 'Tickets por Agente',
    description: 'Promedio de tickets actualmente asignados a los agentes.',
  },
  BLIP_42: {
    title: 'Volumen de Tickets en Cola',
    description: 'Número de tickets en las colas de atención. Considera todos los tickets no asignados en todas las colas de este bot, o en las colas filtradas.',
  },
  BLIP_43: {
    title: 'Tickets en Atención',
    description: 'Total de tickets actualmente en atención: ya asignados o tomados por un agente, con primera respuesta enviada, pero aún no cerrados.',
  },
  BLIP_44: {
    title: 'Agentes en Línea',
    description: 'Número de agentes activos y listos para recibir nuevas atenciones.',
  },
  BLIP_45: {
    title: 'Agentes en Pausa',
    description: 'Número de agentes actualmente en pausa (estándar o personalizada, como almuerzo o baño) y que por tanto no reciben nuevas atenciones.',
  },
  BLIP_46: {
    title: 'Agentes Fuera de Línea',
    description: 'Número de agentes inactivos que no pueden recibir nuevas atenciones.',
  },
  BLIP_47: {
    title: 'Gestión de Atención - Asignado/En Atención',
    description: 'Lista de atenciones ya asignadas a un agente y las atenciones en curso.',
  },
  BLIP_48: {
    title: 'Gestión de Atención - En Espera de Atención',
    description: 'Lista de atenciones en la cola de atención y aún no asignadas a un agente.',
  },
  BLIP_49: {
    title: 'Gestión de Atención - Agentes',
    description: 'Lista de atenciones asignadas agrupadas por agente.',
  },
  BLIP_50: {
    title: 'Gestión de Atención - Colas',
    description: 'Lista de atenciones agrupadas por cola.',
  },
  BLIP_51: {
    title: 'Gestión de Atención - Etiquetas',
    description: 'Lista de atenciones finalizadas agrupadas por etiquetas.',
  },
};
